var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStripeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3887 61C48.2334 61 61.8887 47.3447 61.8887 30.5C61.8887 13.6553 48.2334 0 31.3887 0C14.544 0 0.888672 13.6553 0.888672 30.5C0.888672 47.3447 14.544 61 31.3887 61Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0092 23.7138C29.0092 22.2803 30.1834 21.7161 32.1354 21.7161C34.9414 21.7161 38.4794 22.5701 41.2854 24.0798V15.4178C38.2202 14.1978 35.2007 13.7251 32.1507 13.7251C24.6629 13.7251 19.6914 17.6291 19.6914 24.1561C19.6914 34.3278 33.7062 32.7113 33.7062 37.1033C33.7062 38.7961 32.2269 39.3451 30.1682 39.3451C27.1029 39.3451 23.1989 38.0946 20.1032 36.4018V45.1706C23.5344 46.6498 26.9962 47.2751 30.1682 47.2751C37.8389 47.2751 43.1154 43.4778 43.1154 36.8746C43.0544 25.8946 29.0092 27.8466 29.0092 23.7138Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "white",
    transform: "translate(0.888672)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeIcon);
export default __webpack_public_path__ + "static/media/stripe-icon.774e1adc21df509ca78ca82c7a6aad2a.svg";
export { ForwardRef as ReactComponent };